/**
 * Copy text to the clipboard. Prefer the Async Clipboard API; fall back to a
 * temporary textarea so copy still works on plain HTTP or when the API rejects.
 */
export async function copyToClipboard(text) {
  if (typeof window === 'undefined' || text == null) return false;
  const s = String(text);
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(s);
      return true;
    } catch {
      // Fall through to legacy path (common on HTTP LAN URLs or permission quirks).
    }
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = s;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.style.top = '0';
    ta.setAttribute('tabindex', '-1');
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, s.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
